import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import Alert from "./commonComponent/Alert/Alert";
import Routing from "./Routing";
import { setError } from "./State";
import useInactivityLogout from "./utils/useInactivityLogout";
import { Toaster } from "sonner";

export default function App() {
  const [alert, setAlert] = useState(false);
  const [alertColor, setAlertColor] = useState(false);
  // const [isLoading, setIsLoading] = useState(true);
  const [alertMessage, setAlertMessage] = useState(" Oops! ");
  setError(setAlert, setAlertMessage, setAlertColor);
  useInactivityLogout();

  useEffect(() => {
    if (alert) {
      let timer = setTimeout(function () {
        setAlert(false);
      }, 4000);
      // clear on component unmount
      return () => {
        clearInterval(timer);
      };
    }
  }, [alert]);

  return (
    <>
      {/* <Loader cName={isLoading ? "show" :"hide"} /> */}
      <Routing />
      <Toaster position="top-right" richColors />
      <Alert
        message={alertMessage}
        cName={alert ? "visible" : "hidden"}
        color={alertColor}
      />
    </>
  );
}

// import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.css";
// import "./App.css";
// import Alert from "./commonComponent/Alert/Alert";
// import Routing from "./Routing";
// import { setError } from "./State";
// import useInactivityLogout from "./utils/useInactivityLogout";
// import { Toaster } from "sonner";

// export default function App() {
//   const [alert, setAlert] = useState(false);
//   const [alertColor, setAlertColor] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("Oops!");

//   setError(setAlert, setAlertMessage, setAlertColor);

//   useInactivityLogout();

//   useEffect(() => {
//     if (alert) {
//       const timer = setTimeout(() => {
//         setAlert(false);
//       }, 4000);

//       return () => clearTimeout(timer);
//     }
//   }, [alert]);

//   return (
//     <div className="appBackground">
//       <div className="mobileApp">
//         <Routing />

//         <Alert
//           message={alertMessage}
//           cName={alert ? "visible" : "hidden"}
//           color={alertColor}
//         />
//       </div>

//       <Toaster position="top-right" richColors />
//     </div>
//   );
// }
